import React from 'react'
import PropTypes from 'prop-types'

import createReactClass from 'create-react-class'

export default function configAwareAppComponentFactory(Component) {
  return createReactClass({
    displayName: 'ConfigWrapper',

    propTypes: {
      config: PropTypes.any,
    },

    childContextTypes: {
      config: PropTypes.object,
    },

    getChildContext() {
      return {
        config: this.props.config,
      }
    },

    render() {
      return <Component {...this.props} />
    },
  })
}
